import { createAction } from '@reduxjs/toolkit';
export const DELETE_ANALYTIC_TEAM_REPORT_CONFIG = 'DELETE_ANALYTIC_TEAM_REPORT_CONFIG';
export const deleteAnalyticTeamReportConfigAction = createAction(DELETE_ANALYTIC_TEAM_REPORT_CONFIG);